import * as Yup from "yup";

export const PermissionSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
  key: Yup.string().trim().required("Key is required"),
});
